define('taoQtiItem/qtiXmlRenderer/renderers/choices/AssociableHotspot',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'associableHotspot',
        template : tpl
    };
});
